{
  "googleAnalytics": {
    "config": "",
    "debug_mode": false
  },
  "semantria": {
    "url": "https://api5-preprod.semantria.com"
  },
  "general": {
    "kitchenResources": "http://localhost:4200",
    "loginMessage": "",
    "loginIcon": "campaign"
  },
  "maintenanceMode": {
    "forceReadonly": "false"
  },
  "socialLogin": {
    "requireHttpCookies": true
  },
  "uploader": {
    "maxFileSizeMB": 50,
    "maxFileSizeOverrides": {
      "Excel": 5
    },
    "allowedFileTypes": {
      "xlsx": "Excel",
      "xls": "Excel",
      "csv": "CSV",
      "json": "JSON",
      "jl": "JSON",
      "jsonl": "JSON",
      "tsv": "TSV"
    },
    "retry": {
      "enableAuto": true,
      "maxAutoAttempts": 3
    }
  },
  "limits": {
    "widgetMaxConcurrent": 3,
    "dateInterval": {
      "minute": {
        "limit_minutes": 1440,
        "fallback": "hour"
      },
      "hour": {
        "limit_minutes": 10080,
        "fallback": "day",
        "drilldown": "minute"
      },
      "day": {
        "limit_minutes": 129600,
        "fallback": "week",
        "drilldown": "hour"
      },
      "week": {
        "drilldown": "day"
      },
      "month": {
        "drilldown": "week"
      },
      "year": {
        "drilldown": "month"
      }
    }
  },
  "rtrelay": {
    "url": "http://localhost:8099",
    "context": "/rtr",
    "suppressErrors": true
  },
  "blender": {
    "url": "http://localhost:8080",
    "telemetry": {
      "endpoint": "/telemetry/logs",
      "enabled": false
    }
  },
  "spote": {
    "queryTopicPurposeGenerationScenarioId": "28cb91b3-7c7d-4f7a-85e8-9aeb1356961d",
    "userReviewGenerationQueryMatchScenarioId": "e3945b16-9574-421b-bf9d-5d3c345e0bff",
    "userReviewGenerationScenarioId": "9aeb50d8-1262-4318-add4-6ffc21b763f5",
    "rephraseUserReviewGenerationScenarioId": "04d304b2-85d3-4663-b152-946a928beba9",
    "smartSummaryByDriverFieldSceneId": "new_smart_summary_v1",
    "smartSummaryByAnalyticItemSceneId": "smart_summary_analytic_item_v2"
  },
  "spotlightAgent": {
    "url": "https://spotlight-agent.semantria.com"
  },
  "aiAssistant": {
    "url": "http://localhost:3000",
    "apiKey": "5638afc7-ab5d-4d3e-943f-5db4347d1807",
    "enabled": false
  }
}
